import { AuthLogin } from "@acko-tech/building-blocks.utils.auth-login-module";
import { getLoginUrl } from "@utils/getLoginUrl";
import { LoginSdkConfig } from "@enums/LoginSdkConfig";

export const initializeLoginSdk = (loginUrl?: string, configName?: string, redirectUrl?: string) => {
  new AuthLogin({
    loginUrl: loginUrl || getLoginUrl(window?.location?.href),
    clientId: process?.env?.NEXT_PUBLIC_AD_CLIENT_ID,
    state: "/auth",
    configName: configName || LoginSdkConfig?.DEFAULT,
    onSuccess: () => {
      if (redirectUrl) window.location.href = redirectUrl;
      else window.location.reload();
    },
    enableScrollOnClose: true,
  });
};
